export default [
  {
    name: "admin-main",
    component: () => import("@/modules/Admin/pages/AdminMain/UI/AdminMain.vue"),
    path: "/admin-dashboard",
    meta: {
      layout: "main",
      auth: true,
      role: ["admin", "branchManager"],
    },
  },
  {
    name: "admin-test-main",
    component: () => import("@/modules/Admin/pages/ProfTest.vue"),
    path: "/admin-test",
    meta: {
      layout: "main",
      auth: true,
      role: ["admin", "branchManager"],
    },
  },
  {
    name: "admin-form-main",
    component: () => import("@/modules/Admin/pages/AdminForm/AdminForm.vue"),
    path: "/admin-form/:type",
    meta: {
      layout: "main",
      auth: true,
      role: ["admin", "branchManager"],
    },
  },
  {
    name: "lead-profile",
    component: () => import("@/modules/Admin/pages/AdminForm/LeadProfile.vue"),
    path: "/lead-profile/:lead_id",
    meta: {
      layout: "main",
      auth: true,
      role: ["admin", "branchManager", "kurator"],
    },
  },
  {
    name: "admin-coins-main",
    component: () => import("@/modules/Admin/pages/AdminCoins/AdminCoins.vue"),
    path: "/admin-coins",
    meta: {
      layout: "main",
      auth: true,
      role: ["admin", "branchManager"],
    },
  },
  {
    name: "admin-mentors-main",
    component: () =>
      import("@/modules/Admin/pages/MentorsList/MentorsList.vue"),
    path: "/admin-mentors",
    meta: {
      layout: "main",
      auth: true,
      role: ["admin", "branchManager", "kurator"],
    },
  },
  {
    name: "admin-groups-main",
    component: () =>
      import("../../modules/Admin/pages/GroupList/GroupList.vue"),
    path: "/admin-groups",
    meta: {
      layout: "main",
      auth: true,
      role: ["admin", "branchManager", "academy"],
    },
  },
  {
    name: "admin-main-space-shop",
    component: () =>
      import("../../modules/Administration/pages/SpaceShop/SpaceShop.vue"),
    path: "/admin-space-shop",
    meta: {
      layout: "main",
      auth: true,
      role: ["admin", "branchManager"],
    },
  },
  {
    name: "admin-main-students",
    component: () =>
      import(
        "../../modules/Administration/pages/StudentsList/StudentsList.vue"
      ),
    path: "/admin-students",
    meta: {
      layout: "main",
      auth: true,
      role: ["admin", "branchManager", "kurator"],
    },
  },
  {
    name: "admin-main-students-status",
    component: () =>
      import(
        "../../modules/Administration/pages/StudentsList/StudentsList.vue"
      ),
    path: "/admin-students/:status",
    meta: {
      layout: "main",
      auth: true,
      role: ["admin", "branchManager", "kurator"],
    },
  },
  {
    name: "admin-main-sms",
    component: () =>
      import("../../modules/Administration/pages/SendSms/SendSms.vue"),
    path: "/admin-sms",
    meta: {
      layout: "main",
      auth: true,
      role: ["admin", "branchManager"],
    },
  },
  {
    name: "admin-main-push",
    component: () =>
      import("../../modules/Administration/pages/SendPush/SendPush.vue"),
    path: "/admin-push",
    meta: {
      layout: "main",
      auth: true,
      role: ["admin", "branchManager", "academy", "bi", "hr", "audit", "kurator"],
      permission: "head_access",
    },
  },
  {
    name: "admin-main-referrals",
    component: () =>
      import("../../modules/Administration/pages/Referrals/ReferralsPage.vue"),
    path: "/admin-referrals",
    meta: {
      layout: "main",
      auth: true,
      role: ["admin", "branchManager"],
    },
  },
  {
    name: "admin-geo-survey",
    component: () =>
      import(
        "../../modules/Administration/pages/GeoSurvey/GeoSurvey.vue"
      ),
    path: "/admin-geo-survey",
    meta: {
      layout: "main",
      auth: true,
      role: ["admin", "branchManager"],
    },
  },
  {
    name: "admin-surveys",
    component: () =>
      import("../../modules/Academy/pages/Surveys/Surveys.vue"),
    path: "/admin-surveys",
    meta: {
      layout: "main",
      auth: true,
      role: ["admin", "branchManager"],
    },
  },
  {
    name: "admin-surveys-geo",
    component: () =>
      import(
        "../../modules/Administration/pages/GeoSurvey/GeoSurvey.vue"
      ),
    path: "/admin-surveys/geo",
    meta: {
      layout: "main",
      auth: true,
      role: ["admin", "branchManager"],
    },
  },
  {
    name: "admin-surveys-topics",
    component: () =>
      import(
        "../../modules/Academy/pages/TopicSurvey/TopicSurvey.vue"
      ),
    path: "/admin-surveys/topics",
    meta: {
      layout: "main",
      auth: true,
      role: ["admin", "branchManager"],
    },
  },
  {
    name: "admin-surveys-lessons",
    component: () =>
      import(
        "../../modules/Academy/pages/LessonRatings/LessonRatings.vue"
      ),
    path: "/admin-surveys/lessons",
    meta: {
      layout: "main",
      auth: true,
      role: ["admin", "branchManager"],
    },
  },
  {
    name: "admin-invoices",
    component: () =>
      import("@/modules/Admin/pages/DebtSummary/DebtSummary.vue"),
    path: "/admin-invoices",
    meta: {
      layout: "main",
      auth: true,
      role: ["admin"],
    },
  },
  {
    name: "admin-ai-usage",
    component: () =>
      import("@/modules/Admin/pages/AIUsage/UI/AIUsage.vue"),
    path: "/admin-ai-usage",
    meta: {
      layout: "main",
      auth: true,
      role: ["admin", "academy"],
    },
  },
];
